<div class="bg-[#f2f2f2] py-24">
  <div class="flex justify-center items-center m-auto font-poppins flex-wrap w-11/12 2xl:w-3/4 lg:w-11/12">
    <div class="w-full 2xl:w-2/4 lg:w-2/4">
      <h2 class="text-2xl text-center">
        Bonjour, eu sou
        <br />
        <strong>Fabiana Nanô</strong>
      </h2>
      <p class="pt-4 text-center text-[#212529CC] w-3/4 m-auto">
        Professora de francês, amante da França, de arte, livros, vinhos e boa
        gastronomia
      </p>
      <div class="m-auto lg:w-[500px] border-t border-gray-600 my-8"></div>
      <div class="w-9/12 m-auto text-center lg:text-left">
        <p class="pt-4 text-[#212529CC]">
          Sou brasileira, moro em São Paulo e ensino francês desde 2008.
        </p>
        <p class="pt-4 text-[#212529CC]">
          Comecei a dar aulas assim que voltei da França. Lá, realizei um
          intercâmbio universitário em Lyon, uma cidade maravilhosa conhecida
          por sua gastronomia e belas paisagens.
        </p>
        <p class="pt-4 text-[#212529CC]">
          Voltei para o Brasil, e desde então descobri a minha grande paixão:
          ensinar esta língua que eu amo tanto.
        </p>
        <p class="pt-4 text-[#212529CC]">
          Ao longo desses anos, tive contato com centenas de alunos e pude
          perceber o que funciona de verdade para eles falarem francês de forma
          fluída e prazerosa.
        </p>
        <p class="pt-4 text-[#212529CC]">
          Reuni neste curso as principais técnicas para você dar os primeiros
          passos nesta língua charmosa e conseguir se comunicar em francês de
          forma satisfatória.
        </p>
      </div>
    </div>
    <div >
      <img
        class="w-[500px] p-4"
        src="images/fabiana-nano-1024x1024.webp"
        alt="" />
    </div>
  </div>
</div>
